export default __webpack_public_path__ + "static/media/ritual_tracking_onboarding.b794a65c.webp";